import { atom } from "recoil";

export const productListAtom = atom({
  key: "productList",
  default: [
    {
      id: 1,
      imageUrls: ["https://cdn.imweb.me/thumbnail/20220610/7902f9ea75514.jpg"],
      name: "목감기에 좋은 건더기 없는 프리미엄 수제 착즙 유자청",
      tags: ["SALE", "BEST", "MD"],
      dcPrice: 13300,
      originalPrice: 15000,
      description:
        "완도 바람 맞고 자란 비타민 가득 유자를 청으로 만나보세요! \n 환절기에 딱! 목감기에 딱! \n 건강한 유자로 맛있게 담근 청년 파머의 유자청",
      likeCount: 0,
      options: [
        {
          stockCount: 80,
          name: "유자청 480g 2병(960g)",
          price: 15200,
        },
        {
          stockCount: 62,
          name: "유자청 1kg 1병",
          price: 13300,
        },
        {
          stockCount: 103,
          name: "착즙유자 500ml",
          price: 18800,
        },
      ],
      location: "전라남도 완도",
      deliveryFee: 3500,
      freeShippingCondition: 50000,
      visible: true,
    },
    {
      id: 2,
      imageUrls: ["https://cdn.imweb.me/thumbnail/20220622/420f289e15350.jpg"],
      name: "국산 강원도 화천 생 아스파라거스 1kg 2kg",
      tags: ["SALE", "BEST"],
      dcPrice: 30000,
      originalPrice: 40000,
      description:
        "미생물을 이용한 친환경 농법으로 길러 더욱 맛있는 국내산 친환경 생 아스파라거스",
      likeCount: 0,
      options: [
        {
          stockCount: 50,
          name: "1kg",
          price: 20000,
        },
        {
          stockCount: 50,
          name: "2kg",
          price: 36000,
        },
      ],
      location: "강원도 화천군",
      deliveryFee: 4000,
      freeShippingCondition: 40000,
      visible: true,
    },
    {
      id: 3,
      imageUrls: [
        "https://cdn.imweb.me/thumbnail/20220714/7a7034b864bd3.jpeg",
        "https://cdn.imweb.me/thumbnail/20220714/7a7034b864bd3.jpeg",
      ],
      name: "돌다리농원 100% 예산 순수생사과즙 100포(50포x2BOX 묶음상품)",
      tags: ["SALE", "BEST"],
      dcPrice: 57000,
      originalPrice: 60000,
      description:
        "한 포로 챙기는 황금 사과! 꿀보다 더 달달한 생사과즙으로 아침식사대용, 간식대용으로 하루의 건강과 달콤함을 챙겨보세요!",
      likeCount: 0,
      options: [
        {
          name: "돌다리농원 100% 예산 순수생사과즙 100포(50포x2BOX 묶음상품)",
          stockCount: 100,
          price: 57000,
        },
      ],
      location: "충청남도 예산",
      deliveryFee: 0,
      freeShippingCondition: 0,
      visible: true,
    },
    {
      id: 4,
      imageUrls: ["https://cdn.imweb.me/thumbnail/20200715/236fbfcdd9cf2.jpg"],
      name: "거창 오가네체리자두 3kg 한 상자",
      tags: ["SALE", "MD", "판매대기"],
      dcPrice: 29000,
      originalPrice: 36000,
      description:
        "거창 오가네체리자두 , 3kg 한상자 (50개 내외), 7/28(목) 일괄 발송, 산지직송 무료배송",
      likeCount: 0,
      options: [
        {
          stockCount: 30,
          name: "거창 오가네체리자두 3kg 한 상자",
          price: 29000,
        },
      ],
      location: "경남 거창",
      deliveryFee: 0,
      freeShippingCondition: 0,
      visible: true,
    },
    {
      id: 5,
      imageUrls: [
        "https://cdn.imweb.me/thumbnail/20220622/24231acb3b26d.jpg",
        "https://cdn.imweb.me/thumbnail/20220622/14552ecdda638.jpg",
        "https://cdn.imweb.me/thumbnail/20220622/bd5f99cee136e.jpg",
        "https://cdn.imweb.me/thumbnail/20220622/7e183dd36962b.jpg",
        "https://cdn.imweb.me/thumbnail/20220622/8f2986621b7d6.jpg",
        "https://cdn.imweb.me/thumbnail/20220622/05f824e3ca20a.jpg",
        "https://cdn.imweb.me/thumbnail/20220622/8aae19266de14.jpg",
        "https://cdn.imweb.me/thumbnail/20220622/86ef7e10d9f73.jpg",
        "https://cdn.imweb.me/thumbnail/20220622/dcc1fcc2b4339.jpg",
      ],
      name: "무농약 GAP 인증 국산 청양 블루베리 2kg, 4kg, 5kg",
      tags: ["SALE", "BEST", "SOLDOUT"],
      dcPrice: 52000,
      originalPrice: 120000,
      description:
        "충남의 알프스라 불리는 청정지역 청양에서 무농약으로 재배한 생 블루베리",
      likeCount: 1,
      options: [
        {
          stockCount: 0,
          name: "2kg",
          price: 52000,
        },
        {
          stockCount: 0,
          name: "4kg",
          price: 92000,
        },
        {
          stockCount: 0,
          name: "5kg",
          price: 109000,
        },
      ],
      location: "충청남도 청양군",
      deliveryFee: 0,
      freeShippingCondition: 0,
      visible: true,
    },
    {
      id: 6,
      imageUrls: [
        "https://cdn.imweb.me/thumbnail/20220622/24231acb3b26d.jpg",
        "https://cdn.imweb.me/thumbnail/20220622/14552ecdda638.jpg",
        "https://cdn.imweb.me/thumbnail/20220622/bd5f99cee136e.jpg",
        "https://cdn.imweb.me/thumbnail/20220622/7e183dd36962b.jpg",
        "https://cdn.imweb.me/thumbnail/20220622/8f2986621b7d6.jpg",
        "https://cdn.imweb.me/thumbnail/20220622/05f824e3ca20a.jpg",
        "https://cdn.imweb.me/thumbnail/20220622/8aae19266de14.jpg",
        "https://cdn.imweb.me/thumbnail/20220622/86ef7e10d9f73.jpg",
        "https://cdn.imweb.me/thumbnail/20220622/dcc1fcc2b4339.jpg",
      ],
      name: "무농약 GAP 인증 국산 청양 블루베리 2kg, 4kg, 5kg",
      tags: ["SALE", "BEST", "SOLDOUT"],
      dcPrice: 52000,
      originalPrice: 120000,
      description:
        "충남의 알프스라 불리는 청정지역 청양에서 무농약으로 재배한 생 블루베리",
      likeCount: 1,
      options: [
        {
          stockCount: 0,
          name: "2kg",
          price: 52000,
        },
        {
          stockCount: 0,
          name: "4kg",
          price: 92000,
        },
        {
          stockCount: 0,
          name: "5kg",
          price: 109000,
        },
      ],
      location: "충청남도 청양군",
      deliveryFee: 0,
      freeShippingCondition: 0,
      visible: true,
    },
    {
      id: 7,
      imageUrls: ["https://cdn.imweb.me/thumbnail/20200715/236fbfcdd9cf2.jpg"],
      name: "거창 오가네체리자두 3kg 한 상자",
      tags: ["SALE", "MD", "판매대기"],
      dcPrice: 29000,
      originalPrice: 36000,
      description:
        "거창 오가네체리자두 , 3kg 한상자 (50개 내외), 7/28(목) 일괄 발송, 산지직송 무료배송",
      likeCount: 0,
      options: [
        {
          stockCount: 30,
          name: "거창 오가네체리자두 3kg 한 상자",
          price: 29000,
        },
      ],
      location: "경남 거창",
      deliveryFee: 0,
      freeShippingCondition: 0,
      visible: true,
    },
    {
      id: 8,
      imageUrls: [
        "https://cdn.imweb.me/thumbnail/20220714/7a7034b864bd3.jpeg",
        "https://cdn.imweb.me/thumbnail/20220714/7a7034b864bd3.jpeg",
      ],
      name: "돌다리농원 100% 예산 순수생사과즙 100포(50포x2BOX 묶음상품)",
      tags: ["SALE", "BEST"],
      dcPrice: 57000,
      originalPrice: 60000,
      description:
        "한 포로 챙기는 황금 사과! 꿀보다 더 달달한 생사과즙으로 아침식사대용, 간식대용으로 하루의 건강과 달콤함을 챙겨보세요!",
      likeCount: 0,
      options: [
        {
          name: "돌다리농원 100% 예산 순수생사과즙 100포(50포x2BOX 묶음상품)",
          stockCount: 100,
          price: 57000,
        },
      ],
      location: "충청남도 예산",
      deliveryFee: 0,
      freeShippingCondition: 0,
      visible: true,
    },
    {
      id: 9,
      imageUrls: ["https://cdn.imweb.me/thumbnail/20220622/420f289e15350.jpg"],
      name: "국산 강원도 화천 생 아스파라거스 1kg 2kg",
      tags: ["SALE", "BEST"],
      dcPrice: 30000,
      originalPrice: 40000,
      description:
        "미생물을 이용한 친환경 농법으로 길러 더욱 맛있는 국내산 친환경 생 아스파라거스",
      likeCount: 0,
      options: [
        {
          stockCount: 50,
          name: "1kg",
          price: 20000,
        },
        {
          stockCount: 50,
          name: "2kg",
          price: 36000,
        },
      ],
      location: "강원도 화천군",
      deliveryFee: 4000,
      freeShippingCondition: 40000,
      visible: true,
    },
    {
      id: 10,
      imageUrls: ["https://cdn.imweb.me/thumbnail/20220610/7902f9ea75514.jpg"],
      name: "목감기에 좋은 건더기 없는 프리미엄 수제 착즙 유자청",
      tags: ["SALE", "BEST", "MD"],
      dcPrice: 13300,
      originalPrice: 15000,
      description:
        "완도 바람 맞고 자란 비타민 가득 유자를 청으로 만나보세요! \n 환절기에 딱! 목감기에 딱! \n 건강한 유자로 맛있게 담근 청년 파머의 유자청",
      likeCount: 0,
      options: [
        {
          stockCount: 80,
          name: "유자청 480g 2병(960g)",
          price: 15200,
        },
        {
          stockCount: 62,
          name: "유자청 1kg 1병",
          price: 13300,
        },
        {
          stockCount: 103,
          name: "착즙유자 500ml",
          price: 18800,
        },
      ],
      location: "전라남도 완도",
      deliveryFee: 3500,
      freeShippingCondition: 50000,
      visible: true,
    },
  ],
});
